import { createUseStyles } from "react-jss";
import { SEVERITY_COLORS } from "./profileConsts";

export const useProfileStyles = createUseStyles({
  controlContainer: {
    width: "750px",
    "& .euiPopover__anchor": {
      width: "100%",
    },
    "& .euiPopover": {
      width: "100%",
    },
  },
  columnHeader: {
    display: "grid",
    gridTemplateColumns: "6.5fr 3.5fr",
    padding: "8px",
    borderBottom: "1px solid var(--border-color)",
    backgroundColor: "var(--card-background)",
    fontWeight: 400,
    "& span:first-child": {
      paddingLeft: "12px",
    },
    "& span:nth-child(2)": {
      paddingLeft: "4px",
    },
  },
  fullWidth: {
    width: "100%",
  },
  selectButton: {
    width: "100%",
    display: "flex",

    justifyContent: "space-between",
    "& > span": {
      justifyContent: "space-between",
    },
    "& .euiButton__content": {
      textDecoration: "none !important",
    },
    "& span": {
      textDecoration: "none !important",
    },
  },
  hideEuiCheckmarks: {
    "& .euiSelectableListItem__iconCheck": {
      display: "none !important",
    },
    "& .euiSelectableListItem__content--selected::after": {
      display: "none !important",
    },
    "& .euiSelectableListItem__prepend": {
      display: "none !important",
    },
    "& .euiSelectableListItem__append": {
      display: "none !important",
    },
  },
  optionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: 0,
    width: "100%",
    boxSizing: "border-box",
    "& > *": {
      width: "100%",
    },
    "& label": {
      width: "100%",
    },
  },
  checkboxLabel: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  overrideTruncation: {
    "& .euiSelectableListItem__text.euiSelectableListItem__text--truncate": {
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "clip",
      display: "block",
      width: "100%",
      flex: 1,
    },
  },
  selectText: {
    color: "var(--text)",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    "& > *": {
      borderBottom: "none !important",
      textDecoration: "none !important",
      "&:hover, &:focus": {
        borderBottom: "none !important",
        textDecoration: "none !important",
      },
    },
  },
  formHeading: {
    color: "var(--text)",
    fontSize: "var(--fs12)",
    fontWeight: 400,
    marginBottom: "16px",
  },
  alertObjectSelectorButton: {
    width: "100%",
    "& > .euiPopover": {
      width: "100%",
    },
    "& .euiPopover__anchor": {
      width: "100%",
    },
  },
});

export const useNewProfilieAlertsAssignStyles = createUseStyles({
  boldText: {
    fontWeight: 700,
  },
  controlContainer: {
    width: "100%",
    "& .euiPopover__anchor": {
      width: "100%",
    },
    "& .euiPopover": {
      width: "100%",
    },
  },
  fullWidth: {
    width: "100%",
  },
  popoverContainer: {
    width: "100%",
    "& .euiPopover__anchor": {
      width: "100%",
    },
    "& .euiPopover": {
      width: "100%",
    },
  },
  selectButton: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    "& > span": {
      justifyContent: "space-between",
    },
    "& .euiButton__content": {
      textDecoration: "none !important",
    },
    "& span": {
      textDecoration: "none !important",
    },
  },
  columnHeader: {
    paddingLeft: "30px",
    display: "grid",
    gridTemplateColumns: "5fr 5fr",
    padding: "8px",
    borderBottom: "1px solid var(--border-color)",
    backgroundColor: "var(--card-background)",
    fontWeight: 400,
    "& span:first-child": {
      paddingLeft: "12px",
    },
    "& span:nth-child(2)": {
      marginLeft: "-2px",
    },
  },
  popoverPanel: {
    width: "950px",
  },
  hideEuiCheckmarks: {
    "& .euiSelectableListItem__iconCheck": {
      display: "none !important",
    },
    "& .euiSelectableListItem__content--selected::after": {
      display: "none !important",
    },
    "& .euiSelectableListItem__prepend": {
      display: "none !important",
    },
    "& .euiSelectableListItem__append": {
      display: "none !important",
    },
    "& .euiFieldSearch": {
      boxShadow: "none",
      borderBottom: "1px solid var(--border-color)",
      borderRadius: "6px 6px 0 0",
    },
    "& .euiFieldSearch--compressed": {
      boxShadow: "none",
    },
  },
  optionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderTop: "1px solid var(--border-color)",
    borderBottom: "1px solid var(--border-color)",
    padding: "8px",
    width: "100%",
    boxSizing: "border-box",
    "& > *": {
      width: "100%",
    },
    "& label": {
      width: "100%",
    },
  },
  checkboxLabel: {
    display: "grid",
    gridTemplateColumns: "5fr 5fr",
    width: "100%",
    alignItems: "center",
    gap: "8px",
    "& > span": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& > span:nth-child(2)": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  overrideTruncation: {
    "& .euiSelectableListItem__text.euiSelectableListItem__text--truncate": {
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "clip",
      display: "block",
      width: "100%",
      flex: 1,
    },
  },
  popoverButton: {
    width: "100%",
    "& .euiButton": {
      width: "100%",
    },
  },
  buttonContainer: {
    width: "100%",
    "& .euiButton": {
      width: "100%",
    },
  },
  popoverDivider: {
    borderTop: "1px solid var(--border-color)",
  },
});

export const useNewProfileAlertsListStyles = createUseStyles({
  tableWrapper: {
    position: "relative",
    border: "1.25px solid var(--border-color)",
    borderRadius: "6px",
    backgroundColor: "var(--card-background)",

    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "var(--card-background)",
      borderRadius: "0 6px 6px 0",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "4px",
      "&:hover": {
        background: "#555",
      },
    },
  },

  table: {
    border: "none !important",
    borderRadius: "0",

    "&.euiBasicTable .euiTable": {
      fontSize: "var(--fs12) !important",
      margin: 0,
      borderCollapse: "collapse",
    },

    "&.euiBasicTable .euiTable tbody tr:last-child td": {
      borderBottom: "none !important",
    },

    "&.euiBasicTable .euiTable tbody tr:last-child th": {
      borderBottom: "none !important",
    },

    "&.euiBasicTable .euiTable .euiTableCellContent__text": {
      fontSize: "var(--fs12) !important",
    },

    "&.euiBasicTable .euiTable td, &.euiBasicTable .euiTable th": {
      fontSize: "var(--fs12) !important",
    },

    "&.euiBasicTable .euiTable .euiText": {
      fontSize: "var(--fs12) !important",
    },

    "&.euiBasicTable .euiTableHeaderCell span": {
      fontSize: "var(--fs12) !important",
      color: "var(--text)",
      textTransform: "uppercase",
    },

    "& thead": {
      position: "sticky",
      top: 0,
      zIndex: 10,
      backgroundColor: "var(--table-header-background)",
    },

    "& thead::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: "1px",
      background: "var(--table-header-background)",
      zIndex: 11,
    },

    "& thead tr": {
      backgroundColor: "var(--table-header-background)",
    },

    "& thead th": {
      backgroundColor: "var(--table-header-background)",
      borderBottom: "1px solid var(--border-color)",
      position: "relative",
    },

    "& thead tr:first-child th:first-child": {
      borderTopLeftRadius: "5px",
    },

    "& thead tr:first-child th:last-child": {
      borderTopRightRadius: "5px",
    },

    "& .euiTableHeaderCellCheckbox": {
      border: "none",
      borderBottom: "1px solid var(--border-color)",
      backgroundColor: "var(--table-header-background)",
    },

    "& tbody tr:first-child td": {
      borderTop: "none",
    },
  },

  severityButton: {
    "& .euiButtonEmpty__text": {
      fontWeight: 600,
    },
  },
});

export const useNewProfileNotificationsStyles = createUseStyles({
  heading: {
    color: "var(--text)",
    fontSize: "var(--fs14)",
    fontWeight: 600,
  },
  severityHeading: {
    composes: "$heading",
    '&[data-severity="Information"]': { color: SEVERITY_COLORS.Information },
    '&[data-severity="Warning"]': { color: SEVERITY_COLORS.Warning },
    '&[data-severity="Critical"]': { color: SEVERITY_COLORS.Critical },
  },
  subheading: {
    color: "var(--text)",
    fontSize: "var(--fs12)",
    fontWeight: 600,
  },
  description: {
    color: "var(--text)",
    fontSize: "var(--fs12)",
    fontWeight: 400,
  },
  popoverPanel: {
    width: "400px",
  },
  controlContainer: {
    paddingBottom: "16px",
    paddingTop: "16px",
    borderBottom: "1px solid var(--border-color)",
    "& .euiPopover__anchor": {
      width: "100%",
    },
    "& .euiPopover": {
      width: "100%",
    },
  },
  rowContainer: {
    "&:first-of-type $controlContainer": {
      paddingTop: 0,
    },
    "&:last-of-type $controlContainer": {
      paddingBottom: 0,
      borderBottom: "none",
    },
  },
  columnHeader: {
    paddingLeft: "30px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    padding: "8px",
    borderBottom: "1px solid var(--border-color)",
    backgroundColor: "var(--table-header-background)",
    fontWeight: 400,
    "& span:first-child": {
      paddingLeft: "12px",
    },
    "& span:nth-child(2)": {
      paddingLeft: "2px",
    },
  },
  checkboxLabel: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    width: "100%",
    alignItems: "center",
  },
});

export const useNewProfileResourcesStyles = createUseStyles({
  boldText: {
    fontWeight: 700,
  },
  controlContainer: {
    width: "950px",
    "& .euiPopover__anchor": {
      width: "100%",
    },
    "& .euiPopover": {
      width: "100%",
    },
  },
  fullWidth: {
    width: "100%",
  },
  popoverContainer: {
    width: "100%",
    "& .euiPopover__anchor": {
      width: "100%",
    },
    "& .euiPopover": {
      width: "100%",
    },
  },
  selectButton: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    "& > span": {
      justifyContent: "space-between",
    },
  },

  popoverPanel: {
    width: "950px",
  },
  hideEuiCheckmarks: {
    "& .euiSelectableListItem__iconCheck": {
      display: "none !important",
    },
    "& .euiSelectableListItem__content--selected::after": {
      display: "none !important",
    },
    "& .euiSelectableListItem__prepend": {
      display: "none !important",
    },
    "& .euiSelectableListItem__append": {
      display: "none !important",
    },
    "& .euiFieldSearch": {
      boxShadow: "none",
      borderBottom: "1px solid var(--border-color)",
      borderRadius: "6px 6px 0 0",
    },
    "& .euiFieldSearch--compressed": {
      boxShadow: "none",
    },
  },
  columnHeader: {
    paddingLeft: "30px",
    display: "grid",
    gridTemplateColumns: "5fr 5fr",
    padding: "8px",
    borderBottom: "1px solid var(--border-color)",
    backgroundColor: "var(--table-header-background)",
    fontWeight: 400,
    "& span:first-child": {
      paddingLeft: "12px",
    },
    "& span:nth-child(2)": {
      marginLeft: "-2px",
    },
  },

  checkboxLabel: {
    display: "grid",
    gridTemplateColumns: "5fr 5fr",
    width: "100%",
    alignItems: "center",
    gap: "8px",
    "& > span": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& > span:nth-child(2)": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },

  optionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderTop: "1px solid var(--border-color)",
    borderBottom: "1px solid var(--border-color)",
    padding: "8px",
    width: "100%",
    boxSizing: "border-box",
    "& > *": {
      width: "100%",
    },
    "& label": {
      width: "100%",
    },
  },
  overrideTruncation: {
    "& .euiSelectableListItem__text.euiSelectableListItem__text--truncate": {
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "clip",
      display: "block",
      width: "100%",
      flex: 1,
    },
  },
  popoverButton: {
    width: "100%",
    "& .euiButton": {
      width: "100%",
    },
  },
  buttonContainer: {
    width: "100%",
    "& .euiButton": {
      width: "100%",
    },
  },
  superSelect: {
    "& .euiSuperSelectControl__placeholder": {
      color: "#343741 !important",
    },
  },
});

export const useNewProfileResourcesListStyles = createUseStyles({
  table: {
    "&.euiBasicTable .euiTable": {
      "& thead": {
        borderRadius: "10px !important",
        backgroundColor: "var(--table-header-background)",
      },
      "& .euiTableHeaderCellCheckbox": {
        border: "none",
      },
    },

    "&.euiBasicTable .euiTable .euiTableCellContent__text": {
      fontSize: "var(--fs14) !important",
    },

    "&.euiBasicTable .euiTable td, &.euiBasicTable .euiTable th": {
      fontSize: "var(--fs14) !important",
    },

    "&.euiBasicTable .euiTable .euiText": {
      fontSize: "var(--fs14) !important",
    },

    "&.euiBasicTable .euiTableHeaderCell span": {
      fontSize: "var(--fs12) !important",
      color: "var(--text)",
      textTransform: "uppercase",
    },
  },
});

export const useSingleProfileStyles = createUseStyles({
  title: {
    fontWeight: 700,
    marginRight: "10px",
    color: "var(--text)",
  },
  colRight: {
    borderLeft: "1px solid var(--border-color)",
    paddingLeft: "16px",
    paddingBottom: "10px",
  },
  tabPanel: {
    minBlockSize: "fit-content",
    height: "auto",
    overflow: "visible",
  },
});
